// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1uCbp","row":"Node_row__24G05","label":"Node_label__2J3wL","footer":"Node_footer__3kBb_"};